import { getUrlVariable } from "./getUrlVariable";

const dayOfTheWeek = new Date().getDay();
const saturdaySevice = { day: 6, servicioCampaign: "17086A095B551C891B113056132B1803" };
window.servicioCampaign = dayOfTheWeek == saturdaySevice.day ? saturdaySevice.servicioCampaign : "15394710892276BB1111042D334A3A02";

const siteServiceMapping = {
  coche: dayOfTheWeek != 6 ? "355CF6ED526FC3CB9D112548082D1B07" : "17086A095B551C891B113056132B1803", //"15394710892276BB1111042D334A3A02",
  autos: "355CF6ED526FC3CB9D112548082D1B07", //"15394710892276BB1111042D334A3A02",
  moto: dayOfTheWeek != 6 ? "355CF6ED526FC3CB9D112548082D1B07" : "17086A095B551C891B113056132B1803", //"15394710892276BB1111042D334A3A02",
  viajes: "4EDF0B5AF099371B160F123450115B06",
  mascota: "528D825D382029C2740F1E4E37381C09",
  mascotas: "528D825D382029C2740F1E4E37381C09",
  salud: "51FD780867EF27CCF711252C440B3D06", //"607439EAFFAC0339D50E60065E574602",
  hogar: dayOfTheWeek != 6 ? "0E39D9820A7EAE7C8511253529215F01" : "AC29FDCD421C374E8811305618133806", //"8F5262A07631F55B620E600653145F00",
  bici: "306CE8363144E287200F1F5B47611404",
  dental: "12902C0AEC567CBA24100B410A341800",
  accidentes: "9D8AAB06A730AEADCD100B410B310204",
  lex: "9065C56A83980F1886100B410B565E06",
  decesos: "62E45B7CC90077E3C211243215602308", //"649BFB4548679649090F1E4E561A0709",
  comunidades: "C3749F1DACF0B3C40010255411345F04",
  Confianza_vida: "E7AEE61EBC2DFCD0C211252419084D01",
};

export function getRPService() {
  const site = window.site;

  let service = siteServiceMapping[site] || "54CCB75DC8DEE442010E600435372103";

  const ori = getUrlVariable()["origen"];
  const origen = ori === "MOVISTA" || ori === "MOVISTA/";
  const tari = ["coche", "moto", "autos"].includes(site);
  const utmSource = getUrlVariable()["utm_source"];
  const origenUrl = getUrlVariable()["origen"];

  if (utmSource && (utmSource === "acierto" || utmSource === "arpem")) {
    service = "D29B79219A6B8589030F204519082309";
  }

  if (origenUrl === "COCHECO" && site === "coche") {
    service = "4B2B4805215CB648961004042C503902";
  }
  if (origen && tari) {
    service = "4600AB2D2B406AF9720F3D3E1E356008";
  }

  // Implementacion para el ticket WCS-33134
  // aqui tenemos una incongruencia con site === 'vida' ya que si la url tiene origen=APP cambia el site
  if (window.location.href.includes("https://calcula.mapfre.es/precio-seguro-vida-modular/")) {
    service = "3F0501CBA4596C66370F0E5919614308";
  }

  return service;
}
